<script setup lang="ts">
import { ref } from "vue";
import { useGlobalStore } from "@/store/global";

const globalStore = useGlobalStore();
const isItemOpen = ref(true);
const showDetails = ref(true);

const props = defineProps({
  journey: {
    type: String,
    required: true
  },
  terminalOneStreamCode: {
    type: String,
    required: true
  }
});

const labels = {
  holdsExplanationHeading:
    globalStore.sitecoreData.terminal_specific[props.terminalOneStreamCode].holds_explanation.holds_explanation_heading,
  holdsExplanation:
    globalStore.sitecoreData.terminal_specific[props.terminalOneStreamCode].holds_explanation[props.journey] || {},
  furtherExtranet:
    props.journey === "import"
      ? globalStore.sitecoreData.terminal_specific[props.terminalOneStreamCode].holds_explanation.further_extranet
      : {}
};
const toggleAccordian = () => {
  isItemOpen.value = !isItemOpen.value;
  showDetails.value = isItemOpen.value;
};
</script>
<template>
  <div class="holds_accordian" @click="toggleAccordian()">
    <span>{{ labels.holdsExplanationHeading }}</span>
    <span :class="['mi-20px', isItemOpen ? 'mi-chevron-up' : 'mi-chevron-down']" aria-hidden="true" />
  </div>
  <div v-if="showDetails" class="hold_explanations_container">
    <div v-for="(message, key) in labels.holdsExplanation" :key="key" class="hold_explanations_container__row">
      <div>
        <strong>{{ key }}</strong>
      </div>
      <div>{{ message }}</div>
    </div>
    <div v-if="Object.keys(labels.furtherExtranet).length" class="hold_explanations_container__row date-range">
      <div>{{ labels.furtherExtranet.futher_info_text }}</div>
      <div>
        <a :href="labels.furtherExtranet.extranet_link" target="_blank">{{ labels.furtherExtranet.extranet_text }}</a>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.holds_accordian {
  background-color: var(--mds_brand_appearance_neutral_default_background-color);
  padding: 20px;
  box-shadow: 0 0 15px 0 rgba(197, 197, 197, 0.5);
  margin: 20px 2px 0 2px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  color: var(--mds_brand_appearance_neutral_weakest_on-background-color);
}
.hold_explanations_container {
  color: var(--mds_brand_appearance_neutral_weakest_text-color);
  background-color: var(--mds_brand_appearance_neutral_weakest_background-color);
  padding: 20px;
  &__row {
    margin: 0 0 25px;
  }
}

.is-hidden {
  min-height: 0;
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  display: none;
}
</style>
